import React from "react";
import "./MileStory.css";

import { appsData } from "../data/appsData";

const app = appsData.milestory;

export default function MileStory() {
  return (
    <>
      <div className="milestory-container">
        {/* Hero Section */}
        <header className="milestory-header">
          <a
            className="milestory-back-btn"
            href="/"
            title="Back"
          >
            {/* Left Arrow SVG Icon */}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="milestory-icon-sm"
            >
              <polyline points="15 18 9 12 15 6"></polyline>
            </svg>
          </a>
          <img
            src={app.banner}
            alt={`${app.name} banner`}
            className="milestory-banner-img"
          />
          <div className="milestory-overlay">
            <img
              src={app.iconPage}
              alt="MileStory logo"
              className="milestory-app-icon"
            />
            <h1 className="milestory-h1">{app.name}</h1>
            <p className="milestory-desc">{app.description}</p>

            {/* Store Buttons */}
            <div className="milestory-buttons">
              <a
                href={app.appStoreLink}
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src="https://upload.wikimedia.org/wikipedia/commons/9/91/Download_on_the_App_Store_RGB_blk.svg"
                  alt="Download on the App Store"
                  className="milestory-store-img"
                />
              </a>
              <a
                href={app.playStoreLink}
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg"
                  alt="Get it on Google Play"
                  className="milestory-store-img"
                />
              </a>
            </div>
          </div>
        </header>

        {/* Features Section */}
        <section className="milestory-features">
          <h2 className="milestory-h2">
            Build your story, one milestone at a time.
          </h2>
          <p className="milestory-features-p">
            Start seeing how much more you can achieve when you keep track of
            life’s moments, big or small. From recurring habits to life-changing
            achievements, MileStory helps you reflect, stay motivated, and
            celebrate your growth.
          </p>

          <ul className="milestory-ul">
            <li>✨ Set goals and track your progress with ease</li>
            <li>📅 Build streaks, records & milestone jokers</li>
            <li>🏆 Add images & personalize your achievements</li>
            <li>📈 Visualize your growth with detailed insights</li>
            <li>🔒 All data stored locally & encrypted — no login needed</li>
            <li>⭐ Premium: Backup, import, unlimited goals & more</li>
          </ul>
        </section>

        {/* Screenshots */}
        <section className="milestory-screenshots">
          <h3 className="milestory-h3">
            MileStory in action
          </h3>
          <div style={{ overflow: "hidden" }}>
            <div className="milestory-flex-center">
              <div className="milestory-scroll-container">
                <div className="milestory-scroll-view">
                  {app.screenshots.map((src, i) => (
                    <img
                      key={i}
                      src={src}
                      alt={`Screenshot ${i + 1}`}
                      className="milestory-screenshot-img"
                    />
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="milestory-cta">
          <h3 className="milestory-cta-h3">
            Start your MileStory today
          </h3>
          <p className="milestory-cta-p">
            Your journey is bigger than you think.
          </p>
          <div className="milestory-x-profile">
            <a
              href={app.xProfile}
              target="_blank"
              rel="noopener noreferrer"
              className="milestory-x-btn"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 1200 1227"
                fill="white"
                className="milestory-x-icon"
              >
                <path d="M714.163 519.284L1160.89 0H1056.54L667.137 450.887L357.328 0H0L464.409 681.821L0 1226.37H104.355L514.264 748.682L842.672 1226.37H1200L714.137 519.284H714.163ZM568.291 686.084L520.562 616.618L142.016 79.6944H306.615L611.412 517.867L659.141 587.333L1056.6 1150.3H891.999L568.291 686.084Z" />
              </svg>
              <span className="milestory-x-text">Follow on X</span>
            </a>
          </div>
        </section>

        {/* Footer */}
        <footer className="milestory-footer">
          <div className="milestory-footer-links">
            <a
              href={app.privacyLink}
              rel="noopener noreferrer"
              className="milestory-footer-link"
            >
              Privacy Policy
            </a>
            <a
              href={app.termsLink}
              rel="noopener noreferrer"
              className="milestory-footer-link"
            >
              Terms of Use
            </a>
          </div>
          <p>© {new Date().getFullYear()} Tilbo Apps. All rights reserved.</p>
        </footer>
      </div>
    </>
  );
}
